/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NonConformanceType {
  Debitor = 'Debitor',
  Kreditor = 'Kreditor',
  Production = 'Production'
}
